import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

/**
 * Blockchain Action message component
 * 
 * Shows a message to the user with continue/cancel buttons
 * and executes callback on confirm action
 */
export function ActionConfirm({visible, message, onConfirm, onCancel, onClose}) {
    const handleCancel = () => {
        closeModal();

        if (typeof onCancel === 'function') {
            onCancel();
        }
    }

    const handleConfirm = () => {
        closeModal();

        if (typeof onConfirm === 'function') {
            onConfirm();
        }
    }

    const closeModal = () => {
        if (typeof onClose === 'function') {
            onClose();
        }
    }

    return (
        <>
            <Modal isOpen={visible} centered={true}>
                <ModalBody>
                    <div style={{ fontFamily: 'SfProText'}}>
                        {message}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleConfirm}>
                        Continue
                    </Button>{' '}
                    <Button color="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}